import ILanguage from '@/admin/helpers/interfaces/language-types'
import { createModel } from '@rematch/core'
import { getAllMenu, importMenu, saveMenu } from '@/services/menu/menuService'
import { getAllLanguages } from '@/services/language/languageService';

const initialState: { menus: any, isloaded: boolean, scrollLeave: boolean } = {
    isloaded: false,
    menus: [],
    scrollLeave: false,

}
export const menuModel = createModel()({
    state: { ...initialState },
    reducers: {

        setMenu(state, payload) {
            return {
                ...state,
                menus: payload.data,
            }
        },
        setIsLoading(state, payload) {

            return {
                ...state,
                isloaded: payload

            }
        },

        setPropertyMenu(state, payload) {
            return {
                ...state,
                scrollLeave: payload
            }
        },

        setSelectedLanguage(state, payload) {


            state.menus.menu.map((item: any, index: number) => {
                if (item.style && item.style === "lang") {
                    item.elements.map((lang: any, index: number) => {
                        if (lang.title === payload) {
                            lang.isSelected = true
                        } else {
                            lang.isSelected = false
                        }
                    })
                }

            })
            return state;
        }



    },
    effects: (dispatch) => ({

        async changePositionProperty(payload) {
           
            this.setPropertyMenu(payload)
        },

        
        async getMenuAsync() {
            const response = await getAllMenu();
            if (response) {
                let language =  [
                        {
                            id: "66f06960ae8228a2220a0a06",
                            language: "Français",
                            isoCode: "fr",
                            flag: "/images/flag/FR.svg",
                            updatedAt: "2024-09-22T19:00:48.870000Z",
                            createdAt: "2024-09-22T19:00:48.870000Z"
                        },
                        {
                            id: "66f06960ae8228a2220a0a07",
                            language: "English",
                            isoCode: "en",
                            flag: "/images/flag/UK.svg",
                            updatedAt: "2024-09-22T19:00:48.894000Z",
                            createdAt: "2024-09-22T19:00:48.894000Z"
                        }
                    ];

                let langList: any = []

                language && language?.map((lang: any, index: number) => {

                    langList = [...langList, { title: lang.language, href: "#", icon: lang.flag, isSelected: lang.language === "English" ? true : false, iSOCode: lang.isoCode }]

                });


                response.data?.menu?.map((item: any, index: number) => {

                    if (item.style && item.style === "lang") {
                        item.elements = langList;
                    }
                })



              



                this.setMenu({ data: response.data })
                return response
            } else {
                this.setMenu({ response: [] })
                return {}
            }

        },

        async saveMenuAsync(payload, rootState) {
            let response = await saveMenu(payload);
            if (response) {

                return response


            } else {
                console.log("else")

            }

        },

        async importMenu(payload){

            return await importMenu(payload)
        }



    }),

})